import {
  CancellationReasonPermissionSet,
  CommentPermissionSet,
  DriverBreakPermissionSet,
  IvrPermissionSet,
  JourneyPermissionSet,
  PermissionSetType,
} from '../../sets'
import { AdminUserPermissionSet } from '../../sets/AdminUserPermissions'
import { AnalyticsPermissionSet } from '../../sets/AnalyticsPermissions'
import { AnnouncementPermissionSet } from '../../sets/AnnouncementPermissions'
import { BulkMessagePermissionSet } from '../../sets/BulkMessagePermissions'
import { ChargePermissionSet } from '../../sets/ChargePermissions'
import { DriverUserPermissionSet } from '../../sets/DriverUserPermissions'
import { DutyPermissionSet } from '../../sets/DutyPermissions'
import { EventPermissionSet } from '../../sets/EventPermissions'
import { FarePassPermissionSet } from '../../sets/FarePassPermissions'
import { FavoriteLocationPermissionSet } from '../../sets/FavoriteLocationPermissions'
import { GroupPermissionSet } from '../../sets/GroupPermissions'
import { LaunchReportingPermissionSet } from '../../sets/LaunchReportingPermissions'
import { NotificationSettingPermissionSet } from '../../sets/NotificationSettingPermissions'
import { OperationalAlertsPermissionSet } from '../../sets/OperationalAlertsPermissions'
import { OrganizationPermissionSet } from '../../sets/OrganizationPermissions'
import { PaymentMethodPermissionSet } from '../../sets/PaymentMethodPermissions'
import { PaymentMethodTypePermissionSet } from '../../sets/PaymentMethodTypePermissions'
import { PromoPermissionSet } from '../../sets/PromoPermissions'
import { RequestPermissionSet } from '../../sets/RequestPermissions'
import { ReviewPermissionSet } from '../../sets/ReviewPermissions'
import { RiderUserPermissionSet } from '../../sets/RiderUserPermissions'
import { ServicePermissionSet } from '../../sets/ServicePermissions'
import { UserBanPermissionSet } from '../../sets/UserBanPermissions'
import { UserFleetAgreementPermissionSet } from '../../sets/UserFleetAgreementPermissions'
import { VehiclePermissionSet } from '../../sets/VehiclePermissions'
import { WebhookPermissionSet } from '../../sets/WebhookPermissions'

/**
 * Ensure that at the root level of the role, we only add permission sets to it and not
 * individual permissions. Individual permissions at this level will not get assigned to the role.
 * If individual permissions are required, create a permission set of one permission and add to the role.
 */
export const CapMetroServiceProviderRole: PermissionSetType[] = [
  RiderUserPermissionSet.View,
  RiderUserPermissionSet.Export,

  DriverUserPermissionSet.View,
  DriverUserPermissionSet.Edit,
  DriverUserPermissionSet.WriteDriverBehaviour,
  DriverUserPermissionSet.Import,
  DriverUserPermissionSet.Export,

  UserBanPermissionSet.View,

  FavoriteLocationPermissionSet.View,
  FavoriteLocationPermissionSet.Edit,
  FavoriteLocationPermissionSet.Delete,

  VehiclePermissionSet.View,
  VehiclePermissionSet.Edit,

  DutyPermissionSet.View,
  DutyPermissionSet.New,
  DutyPermissionSet.Edit,
  DutyPermissionSet.Cancel,
  DutyPermissionSet.Delete,
  DutyPermissionSet.Import,
  DutyPermissionSet.Export,
  DutyPermissionSet.InitiateTriggeredOptimization,
  DutyPermissionSet.ViewVehicleLocation,
  DutyPermissionSet.ViewDriverConversation,
  DutyPermissionSet.StartDriverConversation,
  DutyPermissionSet.CompleteSlot,
  DriverBreakPermissionSet.View,
  DriverBreakPermissionSet.ViewReason,
  DriverBreakPermissionSet.Write,
  DriverBreakPermissionSet.WriteReason,
  DriverBreakPermissionSet.DeleteReason,

  ServicePermissionSet.View,

  AnnouncementPermissionSet.View,
  AnnouncementPermissionSet.Write,

  PromoPermissionSet.View,
  PromoPermissionSet.ApplyToUser,

  FarePassPermissionSet.View,
  FarePassPermissionSet.ViewAllocation,

  RequestPermissionSet.Estimate,
  RequestPermissionSet.CreateUnmatchedRequest,
  RequestPermissionSet.View,
  RequestPermissionSet.ViewDiscounts,
  RequestPermissionSet.Write,
  RequestPermissionSet.LockToDuty,
  RequestPermissionSet.Rematch,
  RequestPermissionSet.EstimateWithOverrides,
  RequestPermissionSet.ViewRequestPredictions,
  RequestPermissionSet.ViewDailyCounts,

  CancellationReasonPermissionSet.View,

  UserFleetAgreementPermissionSet.View,

  GroupPermissionSet.View,

  GroupPermissionSet.ViewMembership,
  GroupPermissionSet.ViewCondition,
  ReviewPermissionSet.View,

  ChargePermissionSet.View,

  PaymentMethodPermissionSet.View,
  PaymentMethodPermissionSet.InitiatePhoneCollection,
  PaymentMethodPermissionSet.Export,
  PaymentMethodPermissionSet.Delete,

  PaymentMethodTypePermissionSet.Export,
  PaymentMethodTypePermissionSet.View,
  PaymentMethodTypePermissionSet.Write,

  NotificationSettingPermissionSet.View,
  BulkMessagePermissionSet.View,

  LaunchReportingPermissionSet.View,
  LaunchReportingPermissionSet.Write,
  LaunchReportingPermissionSet.Delete,
  LaunchReportingPermissionSet.Export,

  AnalyticsPermissionSet.Access,

  OrganizationPermissionSet.ViewConfiguration,
  OrganizationPermissionSet.ViewBackupSettings,

  AdminUserPermissionSet.View,
  AdminUserPermissionSet.EditOwn,

  WebhookPermissionSet.View,
  WebhookPermissionSet.Write,

  OperationalAlertsPermissionSet.Subscribe,

  EventPermissionSet.View,

  /* Ability to post and view comments */
  CommentPermissionSet.View,
  CommentPermissionSet.Write,

  /* Any role that can view a request should be able to view a journey */
  JourneyPermissionSet.View,

  IvrPermissionSet.ViewMetrics,
]
